// extracted by mini-css-extract-plugin
export default {"errorHeader":"ErrorPages_errorHeader__7hS2l","errorAlert":"ErrorPages_errorAlert__YIC+r","errorText":"ErrorPages_errorText__wry3w"};